// extracted by mini-css-extract-plugin
module.exports = {"originalButton":"CommonButton_originalButton__2VFY-","disablebutton":"CommonButton_disablebutton__1sucu"};